import React from 'react';

export interface EventosIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const EventosIcon: React.FC<EventosIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 2v4M8 2v4M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2"/><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m12 8.849 1.58 3.202 3.536.517-2.558 2.492.604 3.52L12 16.917l-3.162 1.662.604-3.52-2.558-2.49 3.535-.518z"/>
    </svg>
  );
};

export default EventosIcon;
